import { render, staticRenderFns } from "./Form13.vue?vue&type=template&id=208990ed&scoped=true"
import script from "./Form13.vue?vue&type=script&lang=ts"
export * from "./Form13.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=208990ed&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208990ed",
  null
  
)

export default component.exports